export default "__VITE_ASSET__Dn_hHGa1__"